<template>
  <v-menu v-if="isIcon" bottom offset-y
    :close-on-content-click="false"
    v-model="config.status.active">
    <template v-slot:activator="{ on }">
      <v-btn small depressed fab
        v-on="on"
        color="secondary darken-1">
        <v-badge overlap
          :content="getItems.length"
          :color=" getItems.length ? 'red' : 'transparent'">
          <v-icon size="20" color="white">fa-clipboard-list</v-icon>
        </v-badge>
      </v-btn>
    </template>
    <ArrangesList :items="getItems" @edit="edit" />
    <SingleEditModal ref="editor" @close="close" />
  </v-menu>
  <v-list-item v-else>
    <v-list-item-avatar>
      <v-icon small>fal fa-clipboard-list</v-icon>
    </v-list-item-avatar>
    <v-list-item-content>申込手配</v-list-item-content>
  </v-list-item>
</template>

<script>
import ArrangesList from './layouts/list'
import SingleEditModal from './modals/edit/single'
export default {
  name: 'cli-arranges-toolkit',
  components: {
    ArrangesList,
    SingleEditModal
  },
  props: [
    'items',
    'icon'
  ],
  data () {
    return {
      config: {
        status: {
          active: false
        }
      },
      store: {
        arranges: []
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init: function () {
    },
    edit: function (req) {
      this.$refs.editor.open({
        item: req
      })
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    }
  },
  computed: {
    isIcon () {
      return this.$props.icon
    },
    getItems () {
      return this.$props.items || []
    }
  }
}
</script>
